import { apiClient } from '../utils/api';

export interface DataSource {
  id: string;
  name: string;
  type: string;
  status?: string;
  created_at?: string;
  file_type?: string;
  file_size?: string;
  row_count?: number;
  updated_at?: string;
}

export interface CreateDataSourceRequest {
  name: string;
  type: string;
  host: string;
  port: number;
  database: string;
  user: string;
  password: string;
}

export interface UploadFileResponse {
  id: string;
  name: string;
  file_type: string;
  file_size: string;
  row_count: number;
  status: string;
  created_at: string;
  updated_at: string;
}

export interface UploadFilesResponse {
  files: UploadFileResponse[];
  total: number;
}

export interface GetFilesResponse {
  files: DataSource[];
  total: number;
}

class DataSourceService {
  async createDataSource(data: CreateDataSourceRequest): Promise<DataSource> {
    const response = await apiClient.post('/api/v1/data-sources', data);
    return response.data;
  }

  async getDataSources(): Promise<DataSource[]> {
    const response = await apiClient.get('/api/v1/data-sources');
    return response.data;
  }

    async deleteDataSource(id: string): Promise<void> {
        await apiClient.delete(`/api/v1/data-sources/${id}`);
    }

    async deleteFileDataSource(id: string): Promise<void> {
        await apiClient.delete(`/api/v1/data-sources/files/${id}`);
    }

  async uploadFiles(files: File[]): Promise<UploadFilesResponse> {
    // This method is now handled in the hook with progress tracking
    // We'll keep this as a fallback
    const formData = new FormData();
    files.forEach((file) => {
      formData.append('files', file);
    });

    const response = await apiClient.post('/api/v1/data-sources/files/upload', formData);
    return response.data;
  }

  async getFiles(): Promise<GetFilesResponse> {
    const response = await apiClient.get('/api/v1/data-sources/files');
    return response.data;
  }
}

const dataSourceService = new DataSourceService();
export default dataSourceService;

// Export the class and types to make this a module
export { DataSourceService };
